module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.f7ab478.woff";